export default __webpack_public_path__ + "static/media/split_img4.0f3f4bd5.svg";